import { gql } from "@apollo/client";

const GET_CHECK_IIA_AVAILABILITY = gql`
  query checkIIAAvailability($homeErasmusCode: String!, $hostErasmusCode: String!) {
    checkIIAAvailability(homeErasmusCode: $homeErasmusCode, hostErasmusCode: $hostErasmusCode) {
      exists
      count
    }
  }
`;

export default GET_CHECK_IIA_AVAILABILITY;
